<template>
  <v-card class="elevation-0" color="transparent">
    <v-card-title class="px-0">
      <h2 class="ml-0 mb-5 section-title">Altere o preços das faixas se achar necessário:</h2>
    </v-card-title>
    <v-card-text class="py-5 px-0">
      <div>
        <vue-slider
          v-model="sliderValues"
          railStyle="#6A4C01"
          dot-size="18"
          height="9px"
          :enable-cross="false"
          :min="minimumValue"
          :max="maximumValue"
          :interval="0.1"
          :minRange="0.1"
          tooltip="none"
          :process="processSlider"
          :dot-options="dotOptions"
        >
          <template v-slot:process="{ style, index }">
            <div class="vue-slider-process" :style="style">
              <div
                v-if="values[index] > 0"
                :class="
                  index % 2 === 0
                    ? ['merge-tooltip', 'vue-slider-dot-tooltip-inner', 'vue-slider-dot-tooltip-inner-top']
                    : ['merge-tooltip-bottom', 'vue-slider-dot-tooltip-inner', 'vue-slider-dot-tooltip-inner-bottom']
                "
              >
                {{ formatTooltip(values[index - 1], values[index]) }}
              </div>
            </div>
          </template>
        </vue-slider>
        <price-range-values :values="values" :colors="colors" :adjustValue="adjustValue" />
      </div>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-spacer></v-spacer>
        <mf-button label="Aplicar novos preços" :loading="loading" @click="loadAndApplyNewPrices" />
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import PriceRangeValues from './PriceRangeValues.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'PriceRangeSlider',
  components: {
    PriceRangeValues,
    VueSlider,
  },
  props: {
    values: {
      type: Array,
      required: true,
    },
    minimumValue: {
      type: Number,
      default: 0,
    },
    maximumValue: {
      type: Number,
      default: 100,
    },
    minimumPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      colors: ['#990066', '#660099', '#190099', '#004d99', '#075A5A', '#0A500A', '#515E00', '#642100', '#6e0000', '#6A4C00'],
      processSlider: (dotsPos) => [
        [0, dotsPos[0], { backgroundColor: this.colors[0] }],
        [dotsPos[0], dotsPos[1], { backgroundColor: this.colors[1] }],
        [dotsPos[1], dotsPos[2], { backgroundColor: this.colors[2] }],
        [dotsPos[2], dotsPos[3], { backgroundColor: this.colors[3] }],
        [dotsPos[3], dotsPos[4], { backgroundColor: this.colors[4] }],
        [dotsPos[4], dotsPos[5], { backgroundColor: this.colors[5] }],
        [dotsPos[5], dotsPos[6], { backgroundColor: this.colors[6] }],
        [dotsPos[6], dotsPos[7], { backgroundColor: this.colors[7] }],
        [dotsPos[7], dotsPos[8], { backgroundColor: this.colors[8] }],
        [dotsPos[8], dotsPos[9], { backgroundColor: this.colors[9] }],
      ],
    }
  },
  computed: {
    sliderValues: {
      get() {
        return this.values
      },
      set(value) {
        this.$emit('update:values', value)
      },
    },
    dotOptions() {
      return this.values.map((value, index) => {
        return this.values.length - 1 === index ? { disabled: true } : { disabled: false }
      })
    },
  },
  methods: {
    adjustValue(value, withoutFormatation = false) {
      return typeof value === 'undefined' || value === 0 ? this.minimumPrice : withoutFormatation ? value : value + 0.01
    },
    formatTooltip(start, end) {
      return `R$${this.adjustValue(start).toFixed(2)} - R$${this.adjustValue(end, true).toFixed(2)}`
    },
    loadAndApplyNewPrices() {
      // loading to indicate that the new prices was apply
      this.loading = true

      setTimeout(() => {
        this.loading = false
        this.$emit('apply-new-prices')
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.merge-tooltip {
  position: absolute;
  left: 50%;
  bottom: 100%;
  transform: translate(-50%, -15px);
}

.merge-tooltip-bottom {
  position: absolute;
  left: 50%;
  top: 40px;
  -webkit-transform: translate(-50%, -15px);
  transform: translate(-50%, -15px);
}

.vue-slider-dot-tooltip-inner-bottom {
  -webkit-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
}
.vue-slider-dot-tooltip-inner-bottom::after {
  bottom: 100%;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-bottom-color: inherit;
}
.vue-slider-dot {
  z-index: 1 !important;
}
</style>
